import { z } from 'zod';
import { IndicatorType, MaType } from '@shared/types';

export const MaInputSchema = z.object({
  type: z.literal(IndicatorType.MA),
  maType: z.nativeEnum(MaType),
  period: z.number()
});

export type MaInput = z.infer<typeof MaInputSchema>;
